// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","ScreenSMMin":"(min-width: 768px)","recipeGridDescription":"G16b33f","recipeGridDescriptionText":"G2d574a"};